import React from 'react';
import { 
	func,
	string,
	object,
	number
} from 'prop-types';

const hasOptionNotRegistered = (answer, newOption, options) => {
	if(answer===newOption) return false;
	return options.length > 0 ? !options.includes(newOption) : true;
};

export default class Container extends React.PureComponent {
    static propTypes = {
    	number : number.isRequired,
    	answer:string,
    	optionsForAnswer:object,
    	onChangeChoice : func,
    	onNextClicked : func,
    	onBackClicked : func,
    	render : func
    }
    constructor(props){
    	super(props);
    	this.state = {
    		errorMessage: '',
    	};
    }

    render(){
    	const {answer, number,optionsForAnswer, onNextClicked,onBackClicked,onChangeChoice,render,...otherProps} = this.props;
    	const {candidates=[],blankSize=0} = optionsForAnswer;

    	const notifyUpdateOption = (value) =>{
    		this.setState({
    			errorMessage: '',
    		});
    		onChangeChoice({
    			...optionsForAnswer,
    			...value
    		});
    	};

    	const addChoice = (value) => {
    		let dst = [...candidates];
    		if(!dst.includes(answer)){
    			dst.push(answer);
    		}
    		if(!hasOptionNotRegistered(answer,value, dst)){
    			this.setState({
    				errorMessage:'ERROR : [' + value + '] is already exist'
    			});
    			return;
    		}
    		dst.push(value);
    		notifyUpdateOption({
    			candidates : dst
    		});
    	};
		
    	const handleChangeBlankSize = (e)=>{
    		notifyUpdateOption({
    			blankSize : Number(e.target.value)
    		});
    	};
		

    	const notifyRemoveChoice = (idx) => {
    		if(candidates.length===0) return;
    		const newChoices = candidates.filter((c,i)=>idx!==i);
    		notifyUpdateOption({
    			candidates : newChoices
    		});
    	};
		
    	const onSort = (candidates) => {
    		notifyUpdateOption({
    			candidates
    		});
    	};
    	return render({
    		answer : answer,
    		number : number,
    		blankSize,
    		handleChangeBlankSize,
    		candidates : candidates,
    		errorMessage : this.state.errorMessage,
    		onBackClicked : onBackClicked,
    		onNextClicked : onNextClicked,
    		answerCandidateListProps : {
    			onSort,
    			onDelete : notifyRemoveChoice,
    		},
	        addChoice,
    	},otherProps);
    }
}
